import React from 'react'
import { Link } from 'react-router-dom';
import { useModal } from '../../../contexts/ModalContext';

export default function ComparisonDetalingEvaluating() {
      const { openQueryModal } = useModal();
  return (
    <>
      <section className='comparisondetaling-evaluating-area'>
        <div className='container'>
          <div className="comparisondetaling-evaluating-wrapper">
            <div className='row align-items-center justify-content-between'>
              <div className='col-lg-7 col-md-7'>
                <div className='comparisondetaling-evaluating-box'>
                  <label>Still Evaluating?</label>
                  <h4 className='heading'>Find the Right Logistics Platform for Your Business</h4>
                  <p>Share your logistics requirements, & we'll demonstrate how Mobility Infotech streamlines operations, reduces costs, and improves delivery performance.</p>
                  <div className='media-detail-cta-btn'>
                    <Link className="theme-btn white-btn" onClick={openQueryModal}> <span>Book a Demo</span>
                    </Link>
                    <Link className="theme-btn" onClick={openQueryModal}> <span>Explore Platform</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className='col-lg-4 col-md-5'>
                <div className='comparisondetaling-evaluating-img'>
                  <img src='/assets/images/comparisondetaling-evaluating.webp' className='img-responsive' alt='Evaluating' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
